import cn from 'classnames'
import * as React from 'react'

import { CheckIcon, PlusIcon } from '../../icon'

import styles from './item.module.scss'

interface IChecklistItem {
  included?: boolean
  tight?: boolean
  children: React.ReactNode
  inverted?: boolean
  isSummary?: boolean
  center?: boolean
  handwriting?: boolean
}

const ChecklistItem = ({
  included = true,
  tight,
  center,
  children,
  inverted = false,
  isSummary = false,
  handwriting = false,
}: IChecklistItem) => (
  <div
    className={cn(
      styles.root,
      tight && styles.tight,
      inverted && styles.free,
      center && styles.center,
      handwriting && styles.handwriting
    )}
  >
    {isSummary ? (
      <PlusIcon active={included} className={styles.check} />
    ) : (
      <CheckIcon active={included} className={styles.check} />
    )}
    {children}
  </div>
)

export default ChecklistItem
